module.exports = function() {
  return new Worker(__webpack_public_path__ + "3bfd19501a26a0afc5e6.worker.js");
};